export const isNavigationActiveCallback = (navState: any) => {
  return navState.isActive ? 'tab is-active' : 'tab';
};
